import { Link } from "react-router-dom";
import PolicyPage, { P, Section } from "@/components/PolicyPage";

export default function Terms() {
  return (
    <PolicyPage eyebrow="Legal" title="Terms & Conditions" testid="terms-page"
      intro="Last updated: June 2026. By using this website and placing an order with SYNC you agree to the terms below.">
      <Section title="About SYNC">
        <P>SYNC is an apparel brand based in Atlanta, Georgia, USA, operating this online store. We do not operate a physical retail storefront.</P>
      </Section>

      <Section title="Orders & made-to-order production">
        <P>All SYNC pieces are made to order. Production takes 3–7 business days, and shipping takes 7–10 business days after production. Timelines are estimates in business days, not guarantees. See our <Link to="/shipping" className="text-signal hover:underline">Shipping Policy</Link>.</P>
        <P>We reserve the right to cancel and refund any order — for example in case of a pricing error or suspected fraud.</P>
      </Section>

      <Section title="Pricing & payment">
        <P>All prices are in US dollars. Payment is processed securely by Stripe at checkout. Applicable taxes and shipping are shown before you pay.</P>
      </Section>

      <Section title="Returns & exchanges">
        <P>Returns and exchanges are handled per our <Link to="/returns" className="text-signal hover:underline">Returns & Exchanges</Link> policy.</P>
      </Section>

      <Section title="Product information">
        <P>We work to display product colors, measurements and details accurately, but minor variations may occur (screens differ, and made-to-order garments can vary by 1–3 cm).</P>
      </Section>

      <Section title="Intellectual property">
        <P>All content on this site — the SYNC name, logo, designs, images and copy — belongs to SYNC and may not be reproduced without permission.</P>
      </Section>

      <Section title="Limitation of liability">
        <P>To the maximum extent permitted by law, SYNC's liability for any claim related to an order is limited to the amount you paid for that order.</P>
      </Section>

      <Section title="Governing law">
        <P>These terms are governed by the laws of the State of Georgia, USA.</P>
      </Section>

      <Section title="Contact">
        <P>Questions about these terms: <a href="mailto:info@thesyncwear.com" className="text-signal hover:underline">info@thesyncwear.com</a></P>
      </Section>
    </PolicyPage>
  );
}
